import React from 'react';
import classNames from 'classnames';

import ProgressLoadingBar from '../ProgressLoadingBar';

export type LoadingIndicatorProgressProps = {
  className?: string;
  textBlock?: React.ReactNode;
  progress?: number;
};
/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({
  className,
  textBlock,
  progress,
}: LoadingIndicatorProgressProps) {
  return (
    <div
      className={classNames(
        'top-50 left-50 absolute z-50 flex flex-col items-center justify-center space-y-5',
        className
      )}
    >
      <div className="w-48">
        <ProgressLoadingBar progress={progress} />
      </div>
      {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
